.ModalUpload {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: var(--overlay);
  padding: 0px 16px 4px 16px;
  overflow-y: auto;
}

.CloseModal {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 11;
}

.CardImageToUpload {
  padding: 16px;
  gap: 16px;
  align-self: stretch;
  border-radius: 5px;
  border: 1px solid var(--colori-neutri-white);
  background: var(--colori-neutri-gray-2);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 4px;
}

.LabelInput {
  color: var(--primary);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.InputTitle {
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  border: none;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
  font-family: var(--font-roboto-slab);
  color: var(--primary);
  font-size: 16px;
}

.InputTitle::placeholder {
  color: var(--colori-neutri-gray);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.InputTitle:focus-visible {
  outline: none;
}

.ContainerButtons {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  width: 100%;
  bottom: 0px;
  z-index: 10;
}

.ButtonRiseleziona {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  border: none;
  color: var(--colori-neutri-gray);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.ButtonUpload {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  margin-left: 8px;
  color: var(--colori-neutri-dark-gray);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.ButtonDuplicate {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: var(--concorso);
  border: none;
  margin-left: 8px;
  color: var(--colori-neutri-dark-gray);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}



.ButtonDuplicate:hover {
  background:var(--concorso-hover)
}
.ButtonDuplicate:active {
  background: white;
}

.ButtonCancel {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--colori-neutri-gray-2);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--primary);
  border: none;
  margin-left: 8px;
  color: var(--primary);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.ButtonUploadErrors {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 5px;
  background: var(--tertiary);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--tertiary);
  border: none;
  margin-left: 8px;
  color: var(--colori-neutri-white);
  text-align: center;
  /* CTA */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.ButtonUploadErrors:hover {
  background: var(--tertiary);
  opacity: 0.8;
}

.ImageToUpload {
  width: 100%;
  height: 220px;
  background-size: contain;
  background-position: center;
  border-radius: 5px;
  background-repeat: no-repeat;
  /* transition: background-image 4s ease-in-out; */
}

.PaginationDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--colori-neutri-gray);
  margin-right: 8px;
}

.PaginationImagesDots {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.PaginationDotActive {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--primary);
  margin-right: 8px;
}

.TitleUpload {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: var(--primary);
  margin-bottom: 16px;
}

.TitleConcorso {
  color: var(--secondary);
  /* Label */
  font-family: var(--font-roboto-slab);
  /* margin-bottom: 16px; */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* padding-top: 24px; */
}

.Categorie {
  font-size: 14px;
  color: var(--primary);
  font-family: var(--font-roboto-slab);
}

.Close {
    cursor: pointer;
}

.UploadAvvenuto {
  color: var(--primary);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.ResponseOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
  padding: 24px 16px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ResponseContainer {
  display: flex;
  width: 100%;
  padding: 40px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: absolute;
  bottom: 0px;
  border-radius: 30px 30px 0px 0px;
  background: var(--overlay, #e9f1f3);
  /* Shadow Overlay */
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.1);
}

.ErrorServer {
  padding: 16px;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  color: white;
  width: 100%;
  margin-top: 8px;
  background-color: var(--tertiary);
  border-radius: 8px;
}

.Error {
  color: var(--tertiary);
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.ErrorMapped {
  color: var(--tertiary);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 8px;
}

.SuccessMapped {
  color: var(--success);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.ErrorBlock {
  background-color: var(--tertiary);
  color: var(--colori-neutri-white);
  padding: 16px 24px;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.SuccessBlock {
  background-color: var(--success);
  color: var(--colori-neutri-white);
  padding: 16px 24px;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.PaginationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--primary);
  text-align: center;
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* @media (hover: hover) and (pointer: fine) { */
@media (min-width: 1024px) or ((hover: hover) and (pointer: fine)) {
  .ModalUploadContainer {
    width: 60%;
    position: relative;

    margin: 0 auto;
  }

  .CardImageToUpload {
    border-radius: 30px;
    margin-top: 0px;
    overflow-y: auto;
  }

  .CloseModal {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    z-index: 11;
  }

  .ContainerButtons {
    margin-top: 8px;
    display: flex;
    position: sticky;
    width: 100%;
    bottom: 4px;
    justify-content: space-between;
    z-index: 999;
  }

  .ResponseOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.2);
    padding: 24px 16px;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ResponseContainer {
    display: flex;
    width: 629px;
    height: 592px;
    padding: 16px 64px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 71px;
    flex-shrink: 0;
    border-radius: 5px;
    background: var(--overlay);
  }
  
  .ButtonUpload:hover {
    background: var(--concorso-hover);
  }
}

.LabelUploadWizard {
  font-size: 12px;
  color: var(--primary);
  cursor: pointer;
  margin-right: 35px;
}

.LabelUploadWizard:hover {
  text-decoration: underline;
}
